import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { FormBuilder, Validators, FormGroup, AbstractControl, ValidationErrors, FormArray } from '@angular/forms';
import { environment } from '../../../../../environments/environment';
import { QualificationsData, Qualifications } from '../../../../@core/interfaces/masters/qualifications';
import { PhysicianqualificationData ,Physicianqualification } from '../../../../@core/interfaces/masters/physicianqualification';
import { Console } from 'console';
import { Router } from '@angular/router';

import { InstitutionsData, Institutions } from '../../../../@core/interfaces/masters/institutions';
import { CountryData,CountryMst } from '../../../../@core/interfaces/masters/country';
import { INgxSelectOption } from 'ngx-select-ex';

@Component({
  selector: 'ngx-doctor-qualification',
  templateUrl: './doctor-qualification.component.html',
  styleUrls: ['./doctor-qualification.component.scss']
})
export class DoctorQualificationComponent implements OnInit {

  
  private tenantId = environment.patientTenantId;
  private branchId = environment.patientBranchId;
  // private tenantId = localStorage.getItem("tenantId");
  // private branchId = localStorage.getItem("branchId");

  @Input() physicianId:any;
  @Output() changeTab: EventEmitter<string> = new EventEmitter<string>();
  @Input() isEdit:boolean=false;
  @Input() isCreate:boolean=false;

  p: number = 1;
  placeholder: string = "Select";
  allowClear: any = true;
  multiple: boolean = false;
  protected readonly unsubscribe$ = new Subject<void>();
  data: Physicianqualification[];
  // isAddComponnet: boolean = false;
  // isEditComponnet: boolean = false;
  isSubmitted: boolean = false;
  isBtnSubmitted: boolean = false;

  qualificationEditForm: FormGroup;

  qualificationsList:Qualifications[];
  qualification:Qualifications[];

  validationData:Physicianqualification[];
  newqualificationData:Physicianqualification;

  phyqualification :Physicianqualification[]=[];

  skills:FormArray;

  institutiondata:Institutions[];
  countryData:CountryMst[];

  ProcedureQuickList: Array<any> =[];

  isconfirmation: boolean = false;

  complaintdialog:boolean=false;


  @Output() dataEvent: EventEmitter<any> = new EventEmitter<any>();

  count: number;
  validYear: boolean=true;



  constructor(protected qualifnSrvc: QualificationsData, 
    protected institnSrvc: InstitutionsData, protected cntrySrvc: CountryData,
    private router: Router,private fb: FormBuilder,
     protected phyqualificationSrvc: PhysicianqualificationData) { 

      this.qualificationEditForm = this.fb.group({             
        skills: this.fb.array([
          this.addrow()
        ]) ,
      }); 

    
     }
 
  ngOnInit(): void {

  // this.physicianId=window.localStorage.getItem("phyID");

  console.log("{{physicianId}}",this.physicianId);
  
   
    this.loadQualifications();
    this.LoadPhyQualification();
    this.loadInstitutions();
    this.loadCountries();


  }

  buttonAdd(): void{

    // this.skills = this.qualificationEditForm.get('skills') as FormArray
    // this.skills.push(this.addrow("","","","","",""));
    // this.isSubmitted = true;
    // this.isBtnSubmitted = true;
    // if (this.qualificationEditForm.valid) {
    console.log(this.qualificationEditForm);
      
    (<FormArray>this.qualificationEditForm.get('skills')).push(this.addrow());

    console.log(this.qualificationEditForm);
    // this.isSubmitted = false;
    // this.isBtnSubmitted = false;
    // }

  }
  delete(i:number){     
    //  this.skills = this.qualificationEditForm.get('skills') as FormArray
    //  this.skills.removeAt(i);

    (this.qualificationEditForm.controls['skills'] as FormArray).removeAt(i);

  }

  addrow():FormGroup{
    
    return this.fb.group({
      qualificationId:[null, Validators.required],  
      qualificationNotes: [null, Validators.required],
      institutionId:[null, Validators.required],
      city:[null],
      country:[null, Validators.required],
      yearofpassing:[null, Validators.required]

    });
  }
 
  continue()
  {
    this.isSubmitted = true;
    this.isBtnSubmitted = true;  
    if (this.qualificationEditForm.valid) {
    this.changeTab.emit();
    this.save();
    }
  }

  
onComplaintChange(event: INgxSelectOption[]) {

 console.log("events = ", event);
 
 
  let dataLength = (this.qualificationEditForm.controls['skills'] as FormArray).length;
  for (let i = 0; i < dataLength; i++) {    

    const proceduresId = event[i]?.value;
    let ServiceIndex = this.qualificationsList.findIndex(x => x.id === proceduresId);

    let formGrpTemp: FormGroup = (this.qualificationEditForm.controls['skills'] as FormArray) as any; 
    formGrpTemp.controls[i].get('qualificationNotes').setValue(this.qualificationsList[ServiceIndex].shortName)  
  }
 
}



  loadlist(){    
   
   
    if(this.phyqualification.length>0){
      if (!((this.qualificationEditForm.controls['skills'] as FormArray).length === this.phyqualification.length)) {
        let diff = Math.abs((this.qualificationEditForm.controls['skills'] as FormArray).length - this.phyqualification.length);
        for (let j = 0; j < diff; j++) {

          this.buttonAdd();          
        }
      }  
    }   

      this.phyqualification.forEach((element, index) => {
        (this.qualificationEditForm.controls['skills'] as FormArray).controls[index].get('qualificationId').setValue(element.qualificationId);
        (this.qualificationEditForm.controls['skills'] as FormArray).controls[index].get('qualificationNotes').setValue((element.qualificationNotes));
        (this.qualificationEditForm.controls['skills'] as FormArray).controls[index].get('city').setValue((element.city));
        (this.qualificationEditForm.controls['skills'] as FormArray).controls[index].get('country').setValue((element.country));
        (this.qualificationEditForm.controls['skills'] as FormArray).controls[index].get('yearofpassing').setValue((element.yearofpassing));
        (this.qualificationEditForm.controls['skills'] as FormArray).controls[index].get('institutionId').setValue((element.institutionId));
        
      });  

  }

 
  get fval():{[key: string]: AbstractControl} { return this.qualificationEditForm.controls; }
  
  loadQualifications(): void {
    
    this.qualifnSrvc.list().pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.qualificationsList = data.value; 
      
    }, (error) => {

    }, () => {

    });
  } 
checkYear(event):void{
var currentYear = (new Date()).getFullYear();
this.validYear = (event>= "1960" && event<=currentYear)? true:false;
}
  loadInstitutions(): void {

    //this.isSubmitted =false;
    this.institnSrvc.list().pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.institutiondata = data.value;
    
    }, (error) => {

    }, () => {

    });
  }  
  loadCountries(): void {

    this.cntrySrvc.list().pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.countryData = data.value;

    }, (error) => {

    }, () => {

    });
  }
  


  LoadPhyQualification(): void{

    this.phyqualificationSrvc.list("physicianqualification/" + this.tenantId + '/' + this.branchId  + '/' + this.physicianId).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
    this.phyqualification = data;   
  

    }, (error) => {

    }, () => {

      this.loadlist();

    });
  }

  complaintCancel()
{
  console.log("in cancel complaint")
  this.complaintdialog=false;
  this.loadInstitutions();
}


addcomplaint(input)
{
  console.log("in add complaint")
  this.complaintdialog=true;  
}


  
  onClear(): void {
    this.qualificationEditForm.reset();
    this.isSubmitted = false;
    this.isBtnSubmitted = false;
  }  

  save(): void {
    console.log("phy = ",this.phyqualification);    
    this.dataEvent.emit({ data: this.qualificationEditForm.controls.skills.value }); 
    if (this.phyqualification.length == 0) {
      // this.onSave();
    }
    // else {
    //   this.onEdit();
    // }
  }
  onCancel(): void {   
    this.dataEvent.emit({ data: this.qualificationEditForm.controls.skills.value }); 
  }
  onSave(): void {
    this.isSubmitted = true;
    this.isBtnSubmitted = true;
    if (this.qualificationEditForm.valid) {
    //  this.physicianId=window.localStorage.getItem("phyID")
     console.log("phyician ID",this.physicianId);     
      this.phyqualificationSrvc.create("physicianqualification/" + this.tenantId + '/' + this.branchId  + '/' + this.physicianId , this.qualificationEditForm.controls.skills.value).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        //this.data = data.value;
      }, (error) => {
        this.isSubmitted = false;
        this.isBtnSubmitted = false;
      }, () => {
        this.isSubmitted = false;
        this.isBtnSubmitted = false;
        this.isconfirmation=true;

       setTimeout(() => { 
         this.isconfirmation = false; 
       }, 4000);


      // this.onCancel();

      });
    }
    else
    {
      this.isBtnSubmitted = false;
   return ; 
    }
  }
  
  onEdit(): void{
    this.phyqualificationSrvc.delete(environment.apiUrl+"/physicianqualification/" + this.tenantId + '/' + this.branchId  + '/' + this.physicianId ).pipe(takeUntil(this.unsubscribe$)).
    subscribe((data: any) => {
    

    }, (error) => {
      
    }, () => { 

    this.isSubmitted = true;
    this.isBtnSubmitted = true;
    this.onSave();
    //this.onCancel();
   
  }); 

  }



}
